import { SxProps, Theme } from "@mui/material";

const adminProtectedRouteStyles: Record<string, SxProps<Theme>> = {
  centered: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "60vh",
    gap: 2,
  },
  message: {
    fontSize: "1rem",
    color: "text.secondary",
  },
};

export default adminProtectedRouteStyles;
